// src/app.js

import React from "react";
import { Route, Switch } from "react-router-dom";
//import { useAuth0 } from "@auth0/auth0-react";

import { NavBar, Footer, Loading } from "./components";
import { Home, Profile, ExternalApi } from "./views";
//import AppContainer from "./layout/app-container";
//import ProtectedRoute from "./auth/protected-route";
import BsContainer from "./layout/bs-container";

import "./app.css";

const App = () => {
  /* const { isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  } */

  return (
    <div id="app" className="d-flex flex-column h-100">
      <NavBar />
      <div className="container flex-grow-1">
        <Switch>
         {/*  <Route path="/" exact component={Home} />
          <Route path="/mm" exact component={AppContainer} /> */}
          <Route path="/" exact component={BsContainer} />
          {/* <ProtectedRoute path="/profile" component={Profile} />
          <ProtectedRoute path="/external-api" component={ExternalApi} /> */}
        </Switch>
      </div>
      <Footer />
    </div>
   /*  <div id="app" className="d-flex flex-column h-100">
      <BsContainer />
    </div> */
  );
};

export default App;
